import styled from 'styled-components'
import { CenteredContainer, devices } from './Common.style'

export const RouteWrapper = styled.div`
  position: relative;
  padding: 1rem;
  padding-top: calc(50px + 1rem);

  &.in-app {
    padding-top: 1rem;
  }

  &.LINEAR {
    padding: 24px;
    padding-top: 74px;
  }
`

interface PageContainerProps {
  hasBreadcrumb?: boolean;
}

export const PageContainer = styled.div<PageContainerProps>`
  position: relative;
  width: 100%;
  min-height: calc(100vh - 100px); /*min-height: 100vh;*/
  ${(props: PageContainerProps) => props.hasBreadcrumb &&
    'margin-top: 50px;'
  }
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  `
export interface SectionProps {
  hAlign?: string;
  linear?: boolean;
  $inverted?: boolean;
}

export const DivW = styled.div`
  width: 100%;
`

export const Section = styled(CenteredContainer) <SectionProps>`
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;

  ${(props) => props.hAlign && 'align-items: flex-start;'}

  padding: ${(props) => (props.linear === true ? '0' : '0.5rem 0')};

  @media ${devices.mobileL} {
    max-width: ${(props) => (props.linear === true ? '100%' : 'calc(100% - 18px)')};
  }

  &.first-footer-section {
    padding-top: 12px;
    border-top: 1px solid ${({ $inverted }) => $inverted ? '#fff' : '#BDBDBD'};
    display: block; 
    margin-bottom: 5px;
  }
`;


export const CaiSection = styled(Section)`
  flex-direction: column;
  align-items: flex-start;
`


export const LSectionDescription = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
`

export const LEndSection = styled(Section)`
    max-width: 100%;
    right: 0px;
    left: 0px;
    top: 0px;
    height: calc(100% + 50px);
    position: fixed;
    background: linear-gradient(45deg, rgb(86, 176, 76), rgb(60, 123, 53));
    padding: 0px 20px;
    //border-top: 1px solid rgb(252, 253, 251);
`

export const LTitleIconSection = styled(Section)`
  flex-direction: row;
  align-items: flex-start;

  @media ${devices.mobileL} {
    max-width: 100%;
  }
`

export const LButtonIconSection = styled(Section)`
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
`

export const LVerticalSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: calc(95vh - 174px);

    &.question {
        height: calc(100vh - 400px);
    }
`

export const LCardSinistro = styled.div`
    font-family: "Roboto-Regular";
    width: 100%;
    border-radius: 12px;
    padding: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    //display: flex;
    //flex-direction: row;

    &.is-in-multi-card {
      box-shadow: none;
      padding: 0;
    }
`

export const LButtonContainer = styled.div`
    width: 60%;
    display: flex;
    gap: 20px;
`

export const IncrementalInputContainer = styled(CenteredContainer)`
  position: relative;
  gap: 1rem;

  button {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    width: 34px;
    height: 34px;
    font-size: 20px;
    border: none;
    color: #fff;
    background-color: #3079c9;
    padding: 0;
    border-radius: 50%;
    cursor: pointer;
  }

  .val {
    font-size: 35px;
  }
`

export const ConfirmContainer = styled(CenteredContainer)`
  gap: 2rem;
  z-index: 9999;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%)
`

export const HListContainer = styled(CenteredContainer)`
  gap: 3rem;
`

